/**
 * CallToAction Component
 *
 * Promotional banner to encourage users to try a feature
 */

import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button, Card } from "@bcc/shared-ui";
import type { CallToAction as CTAType } from "../../content/blog/types";

interface CallToActionProps {
  cta: CTAType;
  variant?: "inline" | "banner";
}

export function CallToAction({ cta, variant = "inline" }: CallToActionProps) {
  if (variant === "banner") {
    return (
      <div className="bg-gradient-to-r from-teal-500 to-cyan-500 rounded-xl p-6 md:p-8 text-white">
        <h3 className="text-xl md:text-2xl font-bold mb-2">{cta.title}</h3>
        <p className="text-teal-100 mb-4">{cta.description}</p>
        <Link to={cta.buttonLink}>
          <Button
            variant="secondary"
            className="bg-white text-teal-600 hover:bg-teal-50"
          >
            {cta.buttonText}
            <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <Card variant="outlined" className="p-6 border-teal-200 bg-teal-50">
      <h4 className="font-semibold text-gray-900 mb-2">{cta.title}</h4>
      <p className="text-gray-600 text-sm mb-4">{cta.description}</p>
      <Link to={cta.buttonLink}>
        <Button variant="primary" size="sm">
          {cta.buttonText}
          <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </Link>
    </Card>
  );
}

export default CallToAction;
